import { DraftSatoSetResponse } from 'api/Responses/SatoResponses';
import { DraftTrayResponse, TrayVideo } from 'api/Responses/TrayResponses';
import { SelectedSetContextState } from './reducer';

const selectSelectedSet = (state: SelectedSetContextState): DraftSatoSetResponse => {
  if (state.selectedSet === null) throw new Error('Tried to get SelectedSet when there is no set selected!');

  return state.selectedSet;
};

const selectSelectedTray = (state: SelectedSetContextState): DraftTrayResponse => {
  if (state.selectedSet === null || state.selectedTrayIndex === null)
    throw new Error('Tried to get SelectedTray when there is no tray selected!');

  return state.selectedSet.trays[state.selectedTrayIndex];
};

const selectSelectedVideo = (state: SelectedSetContextState): TrayVideo | null => {
  if (state.selectedSet === null || state.selectedTrayIndex === null)
    throw new Error('Tried to get SelectedVideo when there is no tray or set selected!');

  return state.selectedVideoIndex !== null
    ? state.selectedSet.trays[state.selectedTrayIndex].videos[state.selectedVideoIndex]
    : null;
};

export const SelectedSetSelectors = {
  selectSelectedSet,
  selectSelectedTray,
  selectSelectedVideo,
};
